import { FC } from 'react';
import { GridItem, GridItemProps } from '@chakra-ui/react';
import { getColorValue } from '@shinetools/sunshine';

import { TOP_BAR_GRID_AREA } from '../../constants';

const Topbar: FC<GridItemProps> = (props) => (
  <GridItem
    {...props}
    boxShadow={`inset 0px -1px 0px ${getColorValue('grey.200')}`}
    gridArea={TOP_BAR_GRID_AREA}
  />
);

export default Topbar;
